import { findTexture } from 'mc_pixi-fiber'
import { Container } from 'pixi.js'

import { Emitter } from 'pixi-particles'

import * as EmitterConfigs from "./emitterConfigs"

export default class ParticleSystem extends Container {

    constructor(configs, textures) {
        super()

        console.assert(configs, "[ParticleSystem] missing configs")
        console.assert(textures, "[ParticleSystem] missing textures")

        if (!Array.isArray(configs)) {
            configs = [configs]
        }

        const emitters = []
        const containers = []

        configs.forEach((configName, index) => {
            const container = new Container()

            let emitterTextures = textures[index]

            if (!Array.isArray(emitterTextures)) {
                emitterTextures = [emitterTextures]
            }

            const particleTextures = emitterTextures.map((texture) => {
                return findTexture(texture)
            })

            const config = EmitterConfigs[configName]
            const emitter = new Emitter(container, particleTextures, config)

            emitter.emit = false
            emitter.autoUpdate = true

            emitters.push(emitter)
            containers.push(container)
            this.addChild(container)
        })

        this.emitters = emitters;
        this.containers = containers;
    }

    start() {
        const { emitters } = this

        emitters.forEach((emitter) => {
            emitter.emit = true
        })
    }

    stop(finishedCallback) {
        const { emitters } = this

        emitters.forEach((emitter) => {
            emitter.emit = false
        })
    }
}


